import { createStore, combineReducers } from 'redux'
import { hamburgerReducer } from './reducers/hamburgerReducer'

const reducer = combineReducers({
    hamburger: hamburgerReducer,
})
  
const store = createStore(reducer)

export default store